<template>
  <CrudList
    title="Solicitudes de trabajo"
    storeName="Work_requests"
    labelAddNew="Agregar Nueva Solicitud de trabajo"
    slot-scope="{ item }"
    sortable
    canSearch
  >
    <template v-slot:country_id="{ item }">
      {{ item.country_id?.name ? item.country_id.name : "" }}
    </template>
  </CrudList>
</template>

<script>
import CrudList from "@/components/Crud/CrudList";

export default {
  components: { CrudList },
};
</script>
